<template>
<footer class="panel footer" data-color="red">
  <div class="rocket slideInUp" v-wow="{ 'animation-name': 'slideInUp'}"></div>
  <div class="container">
    <div class="start-project-block lightSpeedIn" v-wow="{ 'animation-name': 'lightSpeedIn'}">
      <div class="start-project none" v-wow="{ 'animation-name': 'none'}" data-cursor-hover data-cursor-mix-blend-mode="difference">&nbsp; <br />&nbsp;</div>
    </div>
    <div class="footer-bottom fadeInUp" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '.5s'}">
      <div class="footer-bottom-contact">
        <span>US +1 424 343 3782</span>
        <a href="mailto:sales@tib.email" data-cursor-hover data-cursor-mix-blend-mode="difference">sales@tib.email</a>
      </div>
      <div class="footer-bottom-social">
        <a href="https://www.facebook.com/tibdigitaldev/?fref=ts" data-cursor-hover data-cursor-mix-blend-mode="difference" target="_blank">Facebook</a>
        <a href="https://www.instagram.com/tibdigital/" data-cursor-hover data-cursor-mix-blend-mode="difference" target="_blank">Instagram</a>
        <a href="https://www.linkedin.com/company/tib-digital/" data-cursor-hover data-cursor-mix-blend-mode="difference" target="_blank">LinkedIn</a>
        <a href="https://dribbble.com/tibdigital" data-cursor-hover data-cursor-mix-blend-mode="difference" target="_blank">Dribbble</a>
      </div>
    </div>
    <p class="fadeInUp" v-wow="{ 'animation-name': 'fadeInUp', 'animation-delay': '1s'}">&copy; 2020 TIB Digital Pty Ltd.</p>
  </div>
</footer>
</template>

<script>
import $ from 'jquery'
import { TweenMax, Power1, Linear } from 'gsap'
import vueTypeoutText from 'vue-typeout-text'

export default {
  name: 'Footer',
  install (Vue, options) {
    Vue.component('typeout-text', vueTypeoutText)
  },
  methods: {
    handleScroll (event) {
      var $window = $(window)
      var $body = $('body')
      var $panel = $('.panel')
      var scroll = $window.scrollTop()
      $panel.each(function () {
        var $this = $(this)
        var $halfWindow = $window.height() - 100
        if (($this.position().top - $halfWindow) <= scroll && ($this.position().top - $halfWindow) + $this.height() > scroll) {
          $body.removeAttr('class')
          $body.addClass('color-' + $(this).data('color'))
        }
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss'>
  footer{
    float:left;
    width:100%;
    padding:100px 0 100px !important;
    text-align: center;
    position: relative;
    z-index: 1;
    &.locations{
      text-align: left;
      background: transparent;
      .container{
        display: flex;
        justify-content:space-between;
        align-items:center;
        height: auto;
      }
    }
    .rocket{
      position: absolute;
      left:calc(50% - 100px);
      top:calc(50% - 380px);
      width:192px;
      height:403px;
      z-index:-1;
      &:before{
        content:"";
        position: absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background:url(../../src/assets/images/rocket.svg) center no-repeat;
        background-size: auto 100%;
        z-index:0;
      }
      &:after{
        content:"";
        position: absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
        background:url(../../src/assets/images/rocket-glitch.svg) center no-repeat;
        background-size: auto 100%;
        z-index:-1;
        animation-duration: 3s;
        animation-fill-mode: both;
        animation-delay: 3s;
        animation-iteration-count: infinite;
        animation-name: glitch;
      }
    }
    @keyframes glitch {
      0% {transform: translate(0, 0);}
      10% {transform: translate(0, 0);}
      20% {transform: translate(0, 0);}
      30% {transform: translate(0, 0);}
      40% {transform: translate(0, 0);}
      49% {transform: translate(2px, 0);}
      50% {transform: translate(10px, 0);}
      51% {transform: translate(-5px, 0);}
      60% {transform: translate(0, 0);}
      61% {transform: translate(-2px, 0);}
      62% {transform: translate(-10px, 0);}
      66% {transform: translate(5px, 0);}
      70% {transform: translate(0, 0);}
      80% {transform: translate(0, 0);}
      90% {transform: translate(0, 0);}
      to {transform: translate(0, 0);}
    }
    .start-project-block{
      padding:150px 0 50px;
    }
    .start-project{
      display: inline-block;
      font-size:68px;
      font-weight: 500;
      color: #f4eeb4;
      &:after{
        opacity: 0;
      }
      &.v-wow-visible{
        &:after{
          animation-fill-mode: both;
          animation-delay: 3s;
          animation-name: lineVisible;
        }
      }
    }
    @keyframes lineVisible {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .footer-bottom{
      display: flex;
      justify-content:space-between;
      align-items:center;
      flex-wrap:wrap;
      margin-top:200px;
      margin-bottom:30px;
      color:#fffbed;
      font-weight:500;
      &-contact a,
      &-contact span{
        margin-right:50px;
      }
      &-social a{
        margin-left:50px;
      }
    }
    p{
      display:inline-block;
      width:100%;
      text-align:left;
      font-size:12px;
    }
    &.locations{
      .h3-tagline{
        margin-bottom: 100px;
      }
      .locations-left{
        width:50%;
        .h3-tagline{
          animation-duration: 1s;
          animation-fill-mode: both;
          animation-name: fadeInUpSkew2 !important;
          text-align: left;
          line-height: 90px;
          height:180px;
          margin-top: -50px;
          span{
            display: inline-block;
            width:0px;
            overflow: hidden;
            text-align: left;
            white-space: nowrap;
          }
          &.v-wow-visible{
            span{
              animation-duration: .5s;
              animation-fill-mode: both;
              animation-delay: 1s;
              animation-name: titleLetterTyping;
              text-align: left;
            }
          }
        }
      }
      .locations-right{
        width:50%;
        position: relative;
      }
      ul{
        display: flex;
        justify-content:space-between;
        align-items:flex-start;
        flex-wrap:wrap;
        li{
          width:calc(50% - 25px);
          margin-bottom: 50px;
          h6,
          p{
            color:#fffbed;
          }
          h6{
            margin-bottom: 10px;
          }
          p{
            font-size: 18px;
          }
        }
      }
      .footer-bottom{
        margin-top: 100px;
        &-social a{
          margin-left: 0;
          margin-right: 50px;
        }
      }
    }
    .location-pin{
      position: absolute;
      left: calc(50% - 142px);
      top: calc(50% - 212px);
      width: 284px;
      height: 424px;
      z-index: -1;
      &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url(../../src/assets/images/pin-glitch.png) center no-repeat;
        background-size: auto 100%;
        z-index: -1;
        animation-duration: 3s;
        animation-fill-mode: both;
        animation-delay: 3s;
        animation-iteration-count: infinite;
        animation-name: glitch;
      }
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url(../../src/assets/images/pin.png) center no-repeat;
        background-size: auto 100%;
        z-index: 0;
      }
    }
  }

  @media screen and (max-width: 1080px) {
    footer{
      padding: 100px 0 !important;
      p{
        text-align:center !important;
      }
      .rocket{
        top:calc(50% - 300px) !important;
      }
      &.locations{
        .locations-left{
          .h3-tagline{
            height:80px;
          }
          p{
            text-align:left !important;
          }
        }
      }
      .footer-bottom{
        &-contact,
        &-social{
          width:100%;
          margin-bottom:25px;
        }
      }
      .footer-bottom{
        &-contact a,
        &-contact span{
          margin:0 15px !important;
        }
        &-social a{
          margin:0 15px !important;
        }
      }
    }
  }
  @media screen and (max-width: 1024px) {
    footer{
      padding: 0 0 100px !important;
      .rocket{
        top:calc(50% - 350px) !important;
      }
      h4{
        margin-bottom: 100px !important;
      }
      .start-project{
        font-size:40px !important;
        margin: 100px 0;
      }
    }
  }
  @media screen and (max-width: 767px) {
    footer{
      &.locations{
        .locations-left{
          width:100%;
        }
        .locations-right{
          width:100%;
        }
      }
      .rocket{
        top: calc(50% - 350px) !important;
      }
      .start-project-block{
        padding:50px 0 0;
      }
      .footer-bottom{
        &-contact,
        &-social{
          width:100%;
          margin-bottom:25px;
          a{
            display: inline-block;
            margin:0 15px 15px !important;
          }
        }
      }
      .location-pin{
        left:inherit;
        right:0;
        top:inherit;
        bottom:0;
        width: 180px;
        height: 280px;
      }
    }
  }
  @media screen and (max-width: 568px) {
    footer{
      padding:0 0 30px !important;
      a.start-project{
        font-size:34px !important;
      }
      .footer-bottom{
        &-social a{
          font-size:14px;
          margin: 0 5px !important;
        }
      }
    }
  }
  @media screen and (max-width: 480px) {
    footer{
      &.locations{
        ul{
          li{
            width:100%;
          }
        }
      }
      .start-project{
        font-size:26px !important;
      }
    }
  }
</style>
